import httpService from "./httpService";
import utils from "./utils";

export default {

  findById(id) {
    return httpService.get(`/hcCfgCar/${id}`);
  },

  create(form) {
    return httpService.post(`/hcCfgCar`, form);
  },

  update(id, form) {
    return httpService.put(`/hcCfgCar/${id}`, form);
  },

  delete(id) {
    return httpService.delete(`/hcCfgCar/${id}`);
  },

  changeStatus(id) {
    return httpService.put(`/hcCfgCar/${id}/changeStatus`);
  },

  findAll(searchForm, pageable) {
    let params = utils.merge(searchForm, pageable);
    return httpService.get(`/hcCfgCar`, {params: params});
  },
}



// WEBPACK FOOTER //
// ./src/services/hcCfgCarService.js